export default __webpack_public_path__ + "static/media/pepsi.73773655.png";